/** angular */
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
/** end angular */

/** sixense */
import { DsLibSharedModule, DsLibLanguagePickerModule, DsLibCommonModule } from '@sixense/ds-lib-common';
import { DsPasswordService } from '@sixense/ds-roazhon-service';
import { BydFeatureFlagsModule } from '@sixense/byd-feature-flags';
/** end sixense */

/** components */
import { DsLibLoginFormComponent } from './ds-lib-login-form.component';
import { DsLibInputPasswordComponent } from './components/ds-lib-input-password/ds-lib-input-password.component';
import { DsLibResetPasswordComponent } from './components/ds-lib-reset-password/ds-lib-reset-password.component';
import { DsLibLoginButtonComponent } from './components/ds-lib-login-button/ds-lib-login-button.component';
/** end components */

@NgModule({
  declarations: [
    DsLibLoginFormComponent,
    DsLibInputPasswordComponent,
    DsLibResetPasswordComponent,
    DsLibLoginButtonComponent,
  ],
  imports: [DsLibCommonModule, DsLibSharedModule, TranslateModule, DsLibLanguagePickerModule, BydFeatureFlagsModule],
  exports: [DsLibLoginFormComponent],
  providers: [DsPasswordService],
})
export class DsLibLoginFormModule {}
